/* Ashley's Gift Shop — homepage sections (vanilla; works alongside Dawn) */
(function () {
  if (window.__ashHome) return; window.__ashHome = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    root = root || document;
    /* Scroll-triggered staggered reveals */
    var reveals = root.querySelectorAll('.ash-reveal:not(.ash-in)');
    if (reduce || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
      reveals.forEach(function (el) { el.classList.add('ash-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('ash-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      reveals.forEach(function (el) { io.observe(el); });
    }


    /* Copy-link buttons */
    root.querySelectorAll('[data-copy]').forEach(function (b) {
      b.addEventListener('click', function () {
        var t = b.textContent;
        (navigator.clipboard ? navigator.clipboard.writeText(b.getAttribute('data-copy')) : Promise.reject()).then(function () {
          b.textContent = b.getAttribute('data-done') || 'Copied'; setTimeout(function () { b.textContent = t; }, 1800);
        }, function () { window.prompt('Copy this link', b.getAttribute('data-copy')); });
      });
    });

    /* Table of contents: highlight the section in view */
    var toc = root.querySelector('.ash-pg__toc');
    if (toc && 'IntersectionObserver' in window) {
      var links = toc.querySelectorAll('a[href^="#"]');
      var heads = [].map.call(links, function (a) { return document.getElementById(a.getAttribute('href').slice(1)); }).filter(Boolean);
      var tio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          links.forEach(function (a) { a.classList.toggle('is-on', a.getAttribute('href') === '#' + e.target.id); });
        });
      }, { rootMargin: '-25% 0px -60% 0px' });
      heads.forEach(function (h) { tio.observe(h); });
    }

    /* Motif tiles: show the meaning line when mostly on screen (no hover on touch) */
    var motifs = root.querySelectorAll('.ash-motif');
    if ('IntersectionObserver' in window && motifs.length) {
      var mio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.target.classList.toggle('ash-in-view', e.isIntersecting && e.intersectionRatio > 0.6); });
      }, { threshold: [0, 0.6, 1] });
      motifs.forEach(function (m) { mio.observe(m); });
    }

    /* Background video: pause when off-screen */
    root.querySelectorAll('.ash-story__video').forEach(function (vid) {
      if (!('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { vid.play().catch(function () {}); } else { vid.pause(); } });
      }, { threshold: 0.05 }).observe(vid);
    });

    /* Add to cart via Shopify AJAX API, then let Dawn's cart drawer / notification re-render */
    root.querySelectorAll('.ash-add[data-add]').forEach(function (btn) {
      if (btn.dataset.bound) return; btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-variant');
        if (!id) return;
        var label = btn.textContent;
        btn.disabled = true; btn.textContent = btn.getAttribute('data-adding') || 'Adding…';
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var body = { items: [{ id: Number(id), quantity: 1 }] };
        if (cart && cart.getSectionsToRender) {
          body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }
        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' }, body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) { throw new Error(res.description || 'error'); }
            if (cart && cart.renderContents) {
              try { cart.renderContents(res); } catch (e) { /* ignore drawer errors */ }
            }
            return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
              var bubble = document.getElementById('cart-icon-bubble');
              if (bubble && !(cart && cart.renderContents)) { bubble.innerHTML = '<span class="cart-count-bubble"><span aria-hidden="true">' + c.item_count + '</span></span>'; }
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: c }));
            });
          })
          .then(function () {
            btn.textContent = btn.getAttribute('data-added') || 'Added ✓'; btn.classList.add('ash-is-done');
            setTimeout(function () { btn.textContent = label; btn.classList.remove('ash-is-done'); btn.disabled = false; }, 1800);
          })
          .catch(function () { btn.textContent = btn.getAttribute('data-error') || 'Try again'; btn.disabled = false; });
      });
    });
  }

  /* Signature moment: hero parallax (image drifts slower than the page) */
  function parallax() {
    var para = document.querySelector('.ash-hero__media[data-parallax]');
    if (!para || reduce || window.matchMedia('(max-width:600px)').matches) return;
    var raf = 0;
    var update = function () {
      raf = 0;
      var y = window.scrollY;
      if (y < window.innerHeight * 1.1) { para.style.transform = 'translate3d(0,' + (y * 0.28) + 'px,0)'; }
    };
    window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    update();
  }

  window.AshInit = init;
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(); parallax(); }); }
  else { init(); parallax(); }

  /* Theme editor: re-init when a section is (re)loaded */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); parallax(); });
})();
